import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IProgressGPTReplyModel } from 'api/models';

import { createProgressGPTChat } from 'api/services';
import { toast } from 'react-toastify';

const useProgressGPTCreateChatForm = () => {
    const queryClient = useQueryClient();

    const createChatMutation = useMutation(
        (payload: Pick<IProgressGPTReplyModel, 'message'>) => createProgressGPTChat(payload),
        {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['aiToken'] });
            },
            onError: (err: any) => {
                toast.error(err?.data?.message || 'Something went wrong.');
            },
        }
    );

    const submit = async (values: Pick<IProgressGPTReplyModel, 'message'>) => {
        const chat = await createChatMutation.mutateAsync(values);

        return chat;
    };

    return {
        isLoading: createChatMutation.isPending,
        submit,
    };
};

export default useProgressGPTCreateChatForm;
